/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Device } from '../../models/device';
import { DeviceApiRespModel } from '../../models/device-api-resp-model';

export interface ApiMasterDeviceAddPost$Params {
      body?: Device
}

export function apiMasterDeviceAddPost(http: HttpClient, rootUrl: string, params?: ApiMasterDeviceAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterDeviceAddPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeviceApiRespModel>;
    })
  );
}

apiMasterDeviceAddPost.PATH = '/api/Master/Device/Add';
